import { auth } from "../../../backend/firebaseConfig";
import { normaliseIobNumber } from "./commissionSplitBulkWorkbook";

const API_URL = (process.env.REACT_APP_SNOWFLAKE_API_URL || "http://localhost:10001").replace(/\/$/, "");
const policyKey = (value) => String(value || "").trim().toUpperCase();

export const fetchPolicyIobMatches = async (policyNumbers, userEmail = "") => {
  const token = await auth.currentUser?.getIdToken(true);
  if (!token) throw new Error("Please sign in again before uploading policy numbers.");
  const response = await fetch(`${API_URL}/api/policy-iob-lookup`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "X-User-Email": userEmail,
    },
    body: JSON.stringify({ policyNumbers }),
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(body.error || "Could not look up policy numbers in Snowflake.");
  if (!Array.isArray(body.matches)) throw new Error("The policy lookup returned an invalid response.");
  return body.matches;
};

export const resolvePolicyReferences = (preview, matches) => {
  const byPolicy = new Map(matches.map((match) => [policyKey(match.policyNumber), match.iobReferences]));
  const seenIobs = new Set();
  const rows = preview.rows.map((row) => {
    if (row.status !== "ready") return row;
    const references = byPolicy.get(policyKey(row.policyNumber));
    const iobs = [...new Set((Array.isArray(references) ? references : [])
      .map(normaliseIobNumber).filter(Boolean))];
    let reason = "";
    if (!iobs.length) reason = "No IOB reference was found for this policy number in Snowflake. New plans may take up to 15 minutes to appear.";
    else if (iobs.length > 1) reason = "This policy number matches multiple IOB references. Review it manually.";
    else if (seenIobs.has(iobs[0])) reason = "Another policy number in this file resolves to the same IOB reference.";
    if (reason) return { ...row, status: "invalid", reason };
    seenIobs.add(iobs[0]);
    return { ...row, iobNumber: iobs[0], status: "ready", reason: "" };
  });
  const validRows = rows.filter((row) => row.status === "ready");
  const invalidRows = rows.filter((row) => row.status === "invalid");
  return { ...preview, rows, validRows, invalidRows, validCount: validRows.length, invalidCount: invalidRows.length };
};
